import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	padding: 3em 0 2em 0;

	.jobs-list {
		display: flex;
		flex-flow: column wrap;
		width: 100%;
		gap: 2em;

		.job-box {
			display: flex;
			border: 0.08em solid ${vars.colorBorder};
			width: 100%;
			overflow: hidden;
			max-height: 9em;
			cursor: pointer;

			.job-logo-container {
				width: 11em;
				border-right: 0.08em solid ${vars.colorBorder};
				padding: 2em;
				display: flex;
				place-content: center;
				place-items: center;

				.job-logo {
					width: 6em;
					height: 6em;
					object-fit: scale-down;
				}
			}

			.job-details-mobile {
				display: none;
			}

			.job-details-desktop {
				width: 80%;
				display: flex;
				flex-flow: column nowrap;
				justify-content: space-between;
				align-items: flex-start;
				padding: 2em 2em 1em 2em;

				.job-header {
					width: 100%;
					display: flex;
					justify-content: space-between;
					text-decoration: none;
					color: ${vars.colorBlack};

					.job-name {
						font-size: 1em;
						font-weight: 600;
						width: 60%;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}

					.job-others {
						font-size: 0.8em;
						width: 40%;
						display: flex;
						justify-content: flex-end;
						gap: 1em;

						.job-city {
							text-transform: capitalize;
						}
					}
				}

				.job-company-name {
					font-size: 0.8em;
				}

				.job-company-info {
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 0.8em;
					width: 100%;

					.job-company-info-details {
						margin: 0 1em 0 0;
					}

					.job-buttons {
						display: flex;
						justify-content: flex-end;
						gap: 1em;
						font-weight: 600;

						.button {
							cursor: pointer;
							background: transparent;
							border: 0;
							display: flex;
							align-items: center;
							justify-content: center;
							gap: 0.3em;
						}

						.button-map {
							text-decoration: none;
							color: ${vars.colorText}
						}
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.jobs-list {
			.job-box {
				height: 11em;
				max-height: 11em;

				.job-logo-container {
					width: 25%;
					border-right: 0.08em solid ${vars.colorBorder};
					padding: 1em;
					display: flex;
					place-content: center;
					place-items: center;

					.job-logo {
						width: 100%;
						height: 100%;
						object-fit: scale-down;
					}
				}

				.job-details-desktop {
					display: none;
				}

				.job-details-mobile {
					display: flex;
					flex-flow: column wrap;
					place-content: flex-start space-around;

					width: 75%;
					padding: 1em;
					position: relative;

					.job-name {
						color: ${vars.colorText};
						text-decoration: none;
						font-size: 1.1em;
						font-weight: 600;

						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						overflow: hidden;
						margin-right: 2em;
					}

					.job-company-name {
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}

					.job-city {
						text-transform: capitalize;
						display: flex;
						align-items: center;
						gap: 1em;
					}

					.job-save-button {
						position: absolute;
						right: 0.5em;
						top: 0.5em;

						.button {
							.button-content {
								display: none;
							}
						}
					}

					.job-map-icon {
						position: absolute;
						right: 0.5em;
						bottom: 0.5em;
						padding: 0.4em
					}
				}
			}
		}
	}
`;
